import { bool, boolean, number, object } from "yup";
import { IHealthQuoteClient } from "../interfaces/form/health/IHealthQuoteClient";
import { isSelected } from "./ValidationHelpers";

const client = object<IHealthQuoteClient>({
    isSelected: bool().notRequired().default(false),
    excess: isSelected(number(), number().required("Please selected an excess amount")),
    hasDentalAndOpticalOption: isSelected(
        boolean(),
        boolean().default(false).notRequired()
    ),
    hasGPOption: isSelected(boolean(), boolean().default(false).notRequired()),
    hasSpecialistsAndTestsOption: isSelected(
        boolean(),
        boolean().default(false).notRequired()
    )
});

export default { client };
